import { z } from 'zod';

export const CHANNEL_GUIDE_COLLECTION = 'channelGuides';

export enum TransportStream {
  UDP = 'tsoverudp',
  RPT = 'tsoverrtp',
  HTTP = 'http',
}

export const ChannelSchema = z.object({
  id: z.string(),
  ip: z
    .string()
    .nonempty('IP address is required')
    .regex(
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      'Invalid IP address format'
    )
    .default(''),
  port: z.coerce
    .number()
    .int('Must be a whole number')
    .min(1, 'Number must be at least 1')
    .max(65535, 'Number must be at most 65535'),
  name: z.string().nonempty('Name is required').default(''),
  transportStream: z.nativeEnum(TransportStream).default(TransportStream.UDP),
  pnum: z.coerce
    .number()
    .int('Must be a whole number')
    .min(0, 'Number must be at least 0')
    .max(999, 'Number must be at most 15'),
  activated: z.boolean().default(true),
});

export const ChannelGuideSchema = z.object({
  id: z.string().optional(),
  name: z.string().nonempty('Name is required').default(''),
  channels: z.array(ChannelSchema).optional().default([]),
  suiteId: z.string().optional().default(''),
  pin: z.string().optional().default(''),
  createdAt: z.date().optional(),
  /** sha256 of the file the players receive; written by the agent when the
   *  channels change. Compared with each TV's loadedGuide.hash. */
  hash: z.string().optional(),
});

export type Channel = z.infer<typeof ChannelSchema>;
export type ChannelGuide = z.infer<typeof ChannelGuideSchema>;
